import { createSlice } from '@reduxjs/toolkit';
import { ICompaniesStructure } from '../../../forms/components/company-structure/ICompanyStructure';
import { CompanySubQuestionReducer } from '../../reducers/CompanySubQuestionReducer';

const initialState: ICompaniesStructure = {
	list: [],
};

export const companyStructureSlice = createSlice({
	name: 'company-structure',
	initialState,
	reducers: CompanySubQuestionReducer,
});

export const { addCompany, deleteCompany, editCompany, addMultipleCompanies } =
	companyStructureSlice.actions;

export default companyStructureSlice.reducer;
